import React from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Environment, useGLTF } from '@react-three/drei';

const AvatarModel = ({ url }) => {
  const { scene } = useGLTF(url);
  return <primitive object={scene} scale={1.5} />;
};

const GLBViewer = ({ modelUrl }) => (
  <div style={{ height: '800px', width: '100%' }}>
    <Canvas camera={{ position: [0, 1.6, 2.5] }}>
      <ambientLight />
      <Environment preset="city" />
      <AvatarModel url={modelUrl} />
      <OrbitControls />
    </Canvas>
  </div>
);

export default GLBViewer;
